<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="px-2.5"
    >
      <el-form-item
        label="采购名称"
        prop="name"
        :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
      >
        <el-input v-model="state.model.name"></el-input>
      </el-form-item>
      <!-- <ul class="grid gap-x-5" style="grid-template-columns: 1fr auto 150px">
        <el-form-item
          label="采购名称"
          prop="name"
          :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item
          label="名称"
          prop="name"
          :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
        >
          <el-switch
            v-model="state.model.status"
            active-text="启用"
            inactive-text="禁用"
            inline-prompt
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
        <el-form-item
          label="名称"
          prop="name"
          :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
        >
          <el-input-number
            v-model="state.model.money"
            class="number-input-left number-input-suffix !w-full"
            suffix="%"
          ></el-input-number>
        </el-form-item>
      </ul> -->
      <ul class="grid gap-x-5" style="grid-template-columns: auto 1fr">
        <el-form-item
          label="供应商采购"
          prop="name"
          :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
        >
          <el-switch
            v-model="state.model.status"
            active-text="启用"
            inactive-text="禁用"
            inline-prompt
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
        <el-form-item
          label="供应商"
          prop="type_id"
          :rules="[
            { required: true, message: '请选择所属甲方', trigger: 'blur' },
          ]"
        >
          <el-select
            v-model="state.model.type_id"
            class="!w-72"
            placeholder="选择所属甲方"
          >
            <el-option
              v-for="item in state.type_data"
              :key="item"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadType"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
      </ul>
    </el-form>
    <el-table
      :data="state.list_data"
      v-loading="!Array.isArray(state.list_data)"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      max-height="65vh"
      border
      style="border-color: #f00"
    >
      <el-table-column label="类型" prop="lx" :formatter="$tab_TextFormat" />
      <el-table-column
        label="所属会场"
        prop="lx"
        :formatter="$tab_TextFormat"
      />
      <el-table-column prop="lx" :formatter="$tab_TextFormat">
        <template #header>
          <div class="c-table-col-header" label1="名称" label2="规格" />
        </template>
      </el-table-column>
      <el-table-column label="单价" prop="lx" :formatter="$tab_TextFormat" />
      <el-table-column prop="lx" :formatter="$tab_TextFormat">
        <template #header>
          <div class="c-table-col-header" label1="数量" label2="天数" />
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="lx" :formatter="$tab_TextFormat" />
      <el-table-column
        label="合计"
        prop="lx"
        align="right"
        :formatter="$tab_MoneyFormat"
      />
    </el-table>
    <div class="submit-box px-2.5">
      <el-button type="warning" size="large" @click="onSubmit">
        暂存
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  meeting_place_detail,
  meeting_place_add,
  meeting_place_edit,
} from "@/http/meeting";
import { data_getHotel, data_getHotelHall } from "@/http/data";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    meeting_id: Number,
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
      },
    });
    onMounted(() => {
      state.model.meeting_id = props.meeting_id;
      onLoadType();
      if (props.id) {
        meeting_place_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data?.data;
          }
        });
      }
    });

    //获取物料类型
    const onLoadType = () => {
      data_getHotelHall(state.model.hotel_id).then((res) => {
        if (res.status == 200) state.hall_data = res.data?.data?.list || [];
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            meeting_place_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            meeting_place_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
      onLoadType,
    };
  },
};
</script>
<style scoped></style>
